import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "./auth";
// import Login from "../pages/Login";

const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? (
    children
  ) : (
    <Navigate to="/admin_login" replace />
  );
};

export default PrivateRoute;
